import React from "react";

const TextSection = () => {
  return (
    <div className="custom__container text__section">
      <h3>Cookie Policy</h3>
      <br />
      <p>
        FlexGrade, LLC (“<span>FlexGrade</span>”) may set and access FlexGrade
        cookies on your computer.
      </p>
      <h6>WHAT ARE ‘COOKIES’?</h6>
      <br />
      <p>
        Cookies are small pieces of information that are stored by your browsers
        on your computer's hard drive. They are often used as a mechanism for
        websites to remember things that a website browser has done there in the
        past, for example, clicking on particular buttons, logging in, or having
        read pages on that site months or years ago.
      </p>
      <h6>HOW DOES FLEXGRADE USE COOKIES?</h6>
      <br />
      <p>
        In common with many other website operators, we use cookies on our
        website. We use them to enrich your experience of using the website by
        allowing us to tailor what you see to what we have learned about your
        preferences during your visits to the site. Our cookies are also used to
        enable us to develop our website to reflect our customers’ interests by
        noting who has seen which pages and advertisements, how frequently
        particular pages are visited and determining the most popular areas of
        our website. We, along with carefully selected third parties, also use
        cookies to show you more relevant advertising online.
      </p>
      <br />
      <p>In general, we use the following types of cookies:</p>
      <br />
      <p>
        STRICTLY NECESSARY COOKIES: These are cookies that are required for the
        operation of our website. They include, for example, cookies that enable
        you to log into secure areas of our website, use the shopping cart
        feature when buying match tickets, hospitality etc.
      </p>
      <br />
      <p>
        ANALYTICAL/PERFORMANCE COOKIES: These allow us to recognise and count
        the number of visitors and see how visitors move around our website when
        they are using it. This helps us to improve the way our website works,
        for example, by ensuring that users can find what they are looking for
        easily.
      </p>
      <br />
      <p>
        FUNCTIONALITY COOKIES: These are used to improve the functional
        performance of the website and make it easier for you to use. For
        example, they are used to remembering that you have previously visited
        the website and asked to remain logged in to the website.
      </p>
      <br />
      <p>
        TARGETING COOKIES: These cookies record your visit to our website and
        your browsing habits, such as the pages you have visited and the links
        you have followed. They are used to deliver advertising which is more
        relevant to your interests and also may be used to limit the number of
        times that you see an advertisement. They may be placed by us or by
        advertising networks with our permission. Please note, these cookies do
        not contain any of your personal information. For details on how to
        manage cookies and how to opt out of targeted marking see below.
      </p>
      <br />
      <p>
        TRACKING COOKIES: These allow us to record data about the user of that
        specific browser, such as your actions on a site, browsing activity,
        purchases and preferences, IP address and geographical location, and the
        like. We will not use tracking cookies without your prior consent.
      </p>
      <h6>USE OF GOOGLE ANALYTICS</h6>
      <br />
      <p>
        Our Website and related Services use Google Analytics, a web analysis
        service provided by Google Inc. (“Google”) which is based on Cookie
        technology. The information generated by the Cookie is usually sent to
        and stored in a Google server in the USA. On behalf of FlexGrade, Google
        will use the generated information to evaluate your use of the website,
        to compile reports on website activities, and to provide the website
        operator with additional services connected with website and Internet
        use. The IP address transmitted by your browser in connection with
        Google Analytics is not collated with other data by Google. Further
        information about the privacy practices of Google Analytics is available
        at www.google.com/policies/privacy/partners/. Further information about
        your option to opt-out of Google Analytics is available at{" "}
        <a href="https://tools.google.com/dlpage/gaoptout">
          tools.google.com/dlpage/gaoptout
        </a>
        .
      </p>
      <br />
      <p>
        MARKETING COOKIES: These cookies tell us if you have seen a specific
        advertisement and how long it has been since you last saw it. This
        information allows us to measure the effectiveness of our online
        advertising campaigns and control the number of times you are shown an
        advert so it does not become too repetitive. We also use cookies to
        measure the effectiveness of our marketing communications, for example
        by telling us if you have opened a marketing email that we have sent
        you.
      </p>
      <h6>MANAGING COOKIES</h6>
      <br />
      <p>
        You can manage cookies by activating the setting on your internet
        browser that allows you to refuse, restrict or block the setting of all
        or some cookies. Please refer to the instructions or the online help
        files available via your relevant browser if you wish to manage cookies
        in this way. Alternatively, please visit{" "}
        <a href="https://allaboutcookies.org">www.allaboutcookies.org</a> for
        further information. To manage cookies relating to targeted advertising
        activities, you can visit{" "}
        <a href="https://youronlinechoices.com">www.youronlinechoices.com</a>.
        To opt out of being tracked by Google Analytics across all websites you
        can visit tools.google.com/dlpage/gaoptout.
      </p>
      <br />
      <p>
        Please note, if you refuse cookies this may mean that you can’t use some
        of the additional features of our website and may not be able to access
        certain parts of the website.
      </p>
      <h6>CHANGES TO THIS COOKIES POLICY</h6>
      <br />
      <p>
        We aim to meet high standards and our policies and procedures are,
        therefore, constantly under review. From time to time we may change how
        we use and place cookies. Accordingly, we recommend that you check this
        page periodically in order to review our current policies and practices.
      </p>
      <h6>CONTACTING US</h6>
      <br />
      <p>
        If you have questions or concerns relating to this Cookie Policy or our
        use of cookies and other technologies, please email us at{" "}
        <a href="mailto:legal@flexgrade.io">legal@flexgrade.io</a>.
      </p>
    </div>
  );
};

export default TextSection;
